import { ToastProvider } from "./ToastContext";
import { LoaderProvider } from "./LoaderContext";

const UIProviders = ({ children }) => {
  return (
    <ToastProvider>
      <LoaderProvider>{children}</LoaderProvider>
    </ToastProvider>
  );
};

export default UIProviders;
